export default path => new URL(path, location.origin).toString();
